import util from '../util';

export const FONT_CREATE = 'FONT_CREATE';
export const AVAILABLE_FONTS = 'AVAILABLE_FONTS';

export const AVAILABLE_FONTS_REQUEST = util.requestType(AVAILABLE_FONTS);
export const AVAILABLE_FONTS_SUCCESS = util.successType(AVAILABLE_FONTS);
export const AVAILABLE_FONTS_FAILURE = util.failureType(AVAILABLE_FONTS);

export const CREATE_FONT_REQUEST = util.requestType(FONT_CREATE);
export const CREATE_FONT_SUCCESS = util.successType(FONT_CREATE);
export const CREATE_FONT_FAILURE = util.failureType(FONT_CREATE);
